export interface TourStep {
  target: string          // CSS selector or data-tour attribute
  title: string
  description: string
  placement: 'top' | 'bottom' | 'left' | 'right'
}

export const dashboardSteps: TourStep[] = [
  {
    target: '[data-tour="sidebar"]',
    title: 'Navigation',
    description: 'Switch between your projects, machines, tools, and usage stats.',
    placement: 'right',
  },
  {
    target: '[data-tour="new-job"]',
    title: 'Create a Job',
    description: 'Start here — upload a drawing and let the AI generate your G-code.',
    placement: 'bottom',
  },
  {
    target: 'a[href="/dashboard/machines"]',
    title: 'Machine Profiles',
    description: 'Your CNC machine configurations. Add travel limits, spindle specs, and controller type.',
    placement: 'bottom',
  },
  {
    target: 'a[href="/dashboard/tools"]',
    title: 'Tool Library',
    description: 'Manage your tool inventory. Import from spreadsheets or add tools manually.',
    placement: 'bottom',
  },
]

export const workspaceSteps: TourStep[] = [
  {
    target: '[data-tour="chat"]',
    title: 'Chat with Trinity',
    description: 'Ask questions, request changes, or tell the AI to regenerate specific operations.',
    placement: 'right',
  },
  {
    target: '[data-tour="code-editor"]',
    title: 'G-code Editor',
    description: 'Your generated G-code with syntax highlighting. Edit directly or let the AI patch it.',
    placement: 'left',
  },
  {
    target: '[data-tour="viewer-btn"]',
    title: '3D Toolpath Viewer',
    description: 'Toggle the 3D visualization to see the toolpath, simulate cuts, and verify geometry.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="tool-crib"]',
    title: 'Tool Crib',
    description: 'View and edit the tools assigned to this job.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="settings"]',
    title: 'Job Settings',
    description: 'Change material or other parameters. The AI will recalculate feeds and speeds.',
    placement: 'bottom',
  },
]
